function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 数组去重
 *
 * @param {*} arr 去重数组
 * @param {string} key 对象数组的key
 * @returns
 */
export function unique(arr, key) {
  return arr.reduce(function (prev, next) {
    if (key) prev.every(function (item) {
      return item[key] !== next[key];
    }) && prev.push(next);else prev.indexOf(next) === -1 && prev.push(next);
    return prev;
  }, []);
}

/**
 * 数组转树
 *
 * @param {*} list 数组
 * @param {*} parentId 关联的parentId
 * @returns
 */
export function arrayToTree(list) {
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return list.filter(function (item) {
    return item.parentId === parentId;
  }).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      children: arrayToTree(list, item.id)
    });
  });
}

/**
 * 树转数组
 *
 * @param {*} list 树结构
 * @param {any[]} newArr
 * @returns
 */
export function treeToArray(list) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  list.forEach(function (item) {
    var children = item.children;
    if (children && children.length) {
      treeToArray(children, newArr);
      // delete item.children
    }

    newArr.push(item);
  });
  return newArr;
}
export function updateArray(arr, where, update) {
  var index = arr.findIndex(where);
  var newItem = _objectSpread({}, update(arr[index]));
  return [].concat(_toConsumableArray(arr.slice(0, index)), [newItem], _toConsumableArray(arr.slice(index + 1)));
}
export function updateTree(tree, where, update) {
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'children';
  return tree.map(function (item) {
    var newItem = _objectSpread({}, item);
    if (where(item)) newItem = update(item);
    if (newItem[children]) {
      newItem = _objectSpread(_objectSpread({}, newItem), {}, _defineProperty({}, children, updateTree(newItem[children], where, update)));
    }
    return newItem;
  });
}
var deepFun = function deepFun(tree, filterFn) {
  if (filterFn(tree)) {
    return tree;
  } else if (tree.children) {
    var newTree = _objectSpread(_objectSpread({}, tree), {}, {
      children: []
    });
    tree.children.forEach(function (item) {
      var newItem = deepFun(item, filterFn);
      if (newItem) newTree.children.push(newItem);
    });
    if (newTree.children.length != 0) {
      return newTree;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

/**
 * 递归筛选树节点
 * @param {Array<any>} data tree data
 * @param {*} filterFn filter函数 (data) => boolean
 * @returns {Array<any>}
 */
export var deepFilter = function deepFilter(data, filterFn) {
  var oldData = JSON.parse(JSON.stringify(data));
  var newData = [];
  oldData.forEach(function (item) {
    var newItem = deepFun(item, filterFn);
    if (newItem) newData.push(newItem);
  });
  return newData;
};

/**
 * 查找树的所有末级节点
 */
export var findTreeLastNodes = function findTreeLastNodes(treeArray) {
  var childrenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var result = [];
  treeArray.forEach(function (item) {
    if (item[childrenKey] && item[childrenKey]['length']) {
      var _item$childrenKey;
      var childrenResult = findTreeLastNodes((_item$childrenKey = item[childrenKey]) !== null && _item$childrenKey !== void 0 ? _item$childrenKey : [], childrenKey);
      result = result.concat(childrenResult);
    } else {
      result.push(item);
    }
  });
  return result;
};

/**
 * 查找树节点，支持多查
 */
export var findTreeNodes = function findTreeNodes(treeArray, where) {
  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var result = [];
  var _iterator = _createForOfIteratorHelper(treeArray),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _item = _step.value;
      if (where(_item)) {
        result.push(_item);
      } else {
        var _item$childrenKey2;
        var nodes = findTreeNodes((_item$childrenKey2 = _item[childrenKey]) !== null && _item$childrenKey2 !== void 0 ? _item$childrenKey2 : [], where, childrenKey);
        if (nodes.length) result = result.concat(nodes);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};

/**
 * 查找某些树节点的所有末级节点
 * 等价于：findTreeNodes -> findTreeLastNodes
 */
export var findTreeNodeLastNodes = function findTreeNodeLastNodes(treeArray, where) {
  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var nodes = findTreeNodes(treeArray, where, childrenKey);
  return findTreeLastNodes(nodes, childrenKey);
};